import { Navigate } from 'react-router-dom';
import { Auth } from '../components/Auth';
import { Logo } from '../components/Logo';
import { useAuth } from '../context/AuthContext';

export function SignupPage() {
  const { user, loading, isConfigured } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-surface-950 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (isConfigured && user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-surface-950">
      <div className="flex flex-col items-center justify-center min-h-screen p-6">
        <div className="mb-8">
          <Logo />
        </div>
        <div className="w-full max-w-md">
          <Auth initialMode="signup" />
        </div>
      </div>
    </div>
  );
}
